import React from 'react';
import { InputParameterConfig } from '../InputParameter';
import LinkedModelsConfig from './LinkedModelsConfig';
import { TUpsertISRProjectDataModelsInput } from '../../Pages/DefineModel/model';

type SB3IntegrationsProps = {
    id: string;
    projectId: string;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
}

const SB3Integrations = ({
                              id,
                              projectId,
                              userProjectDataModels,
                              setUserProjectDataModels
                          }: SB3IntegrationsProps) => {
    return (
        <div id={id}>
            <InputParameterConfig
                id="isr-input-parameter"
                projectId={projectId}
                userProjectDataModels={userProjectDataModels}
                setUserProjectDataModels={setUserProjectDataModels}
            />
            <LinkedModelsConfig
                id="isr-linked-models"
                projectId={projectId}
                userProjectDataModels={userProjectDataModels}
                setUserProjectDataModels={setUserProjectDataModels}
            />
        </div>
    );
};

export default SB3Integrations;
